module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-c1e38fd9e0e74ba58f7a2b77ef29fdd3.svg";